import { React, useState, useEffect, useContext } from "react";
import $ from "jquery";
import "jquery-ui-dist/jquery-ui.css";

import { Model, StylesManager } from "survey-core";
import { Survey } from "survey-react-ui";
import "survey-core/modern.css";
import * as widgets from "surveyjs-widgets";
// import "./Evaluation.scss";
import { Link, useHistory, useParams } from "react-router-dom";
import { newProjectForm } from "../../../survey-templates/create-project.js";
import {
  projectSurveyResult,
  setCurrentClient,
  clientSurveyResult,
} from "../../../utils/helpers/createProject.helpers.js";
import "survey-react/modern.css";
import db from "../../../api/mongodb";
import { defaultOptions1 } from "../../../config/loading-config.js";
import Lottie from "react-lottie";
// import "./Home.scss";
// import "./CreateProject.scss";
import { safeAP_id } from "../../../api/testData";
import Button from "react-bootstrap/Button";

import * as SurveyCore from "survey-core";
import { FunctionFactory } from "survey-core";
import { UserContext } from "../../../api/UserProvider.js";
// import * as SurveyReact from "survey-react-ui";
window["$"] = window["jQuery"] = $;

StylesManager.applyTheme("modern");
require("jquery-ui-dist/jquery-ui.js");
widgets.jqueryuidatepicker(SurveyCore);
widgets.inputmask(SurveyCore);

const CreateClient = (location) => {
  const [isLoading, setIsLoading] = useState(true);
  const [clientSurveyModel, setClientSurveyModel] = useState(new Model({}));
  const user = useContext(UserContext)

  console.log(user)
  useEffect(() => {

    createSurvey();
  }, []);

  const createSurvey = () => {
    db.get("/api/newClientTemplates", {
      headers: {
        Authorization: `${localStorage.getItem("token")}`,
      },
    }).then((clientTemplateResponse) => {
      let survey;
      survey = new Model(clientTemplateResponse.data[0].surveyTemplate);
      survey.completeText = "Create Client";
      survey.completedHtml = "Client successfully created!";

      survey.onComplete.add(
        (sender, options) => {
          const payload = clientSurveyResult(sender.data, user.id);
          payload.safeApId = user.id;

          db.post("/api/clients", payload, {
            headers: {
              Authorization: `${localStorage.getItem("token")}`,
            },
          }).then(
            (clientsResponse) => {},
            (error) => {}
          );
        },
        (error) => {}
      );

      setClientSurveyModel(survey);
      setIsLoading(false);

      // remove clean button
      survey.onUpdateQuestionCssClasses.add(function (sender, options) {
        if (options.question.getType() === "file") {
          options.cssClasses.removeButtonBottom =
            options.cssClasses.removeButton;
        }
      });
    });
  };

  if (isLoading) {
    return <Lottie options={defaultOptions1} height={200} width={200} />;
  }

  return (
    <>
      <div className="project-grid">
        <div className="project-grid-header">
          <h1 className="page-title">Create New Client</h1>
          <div className="grid-list-icons">
            <Link to={`/clients/`}>
              <Button className="btn-primary">Back</Button>
            </Link>
          </div>
        </div>
        <div className="create-project-container">
          <Survey model={clientSurveyModel} />
        </div>
      </div>
    </>
  );
};

export default CreateClient;
